// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"50f6047f","8":"01e725ec","439":"c7f2e8e4","476":"fa6e30d1","558":"98c5724c","703":"b9145e63","724":"598eeeff","858":"d0189320","916":"4514a46d","934":"bee400d1"}[chunkId] + ".chunk.js";
};